import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { WarehousesActions } from './warehouses.actions';
import { WarehouseService } from '../../services/warehouse.service';

@Injectable()
export class WarehousesEffects {
  private actions$ = inject(Actions);
  private svc = inject(WarehouseService);

  loadWarehouses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehousesActions.loadWarehouses),
      mergeMap(() => this.svc.getAll().pipe(
        map(warehouses => WarehousesActions.loadWarehousesSuccess({ warehouses })),
        catchError(err => of(WarehousesActions.loadWarehousesFailure({ error: err.message })))
      ))
    )
  );

  loadWarehousesSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehousesActions.loadWarehousesSummary),
      mergeMap(() => this.svc.getAllSummary().pipe(
        map(summaries => WarehousesActions.loadWarehousesSummarySuccess({ summaries })),
        catchError(err => of(WarehousesActions.loadWarehousesSummaryFailure({ error: err.message })))
      ))
    )
  );

  createWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehousesActions.createWarehouse),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(warehouse => WarehousesActions.createWarehouseSuccess({ warehouse })),
        catchError(err => of(WarehousesActions.createWarehouseFailure({ error: err.message })))
      ))
    )
  );

  updateWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehousesActions.updateWarehouse),
      mergeMap(({ id, dto }) => this.svc.update(id, dto).pipe(
        map(warehouse => WarehousesActions.updateWarehouseSuccess({ warehouse })),
        catchError(err => of(WarehousesActions.updateWarehouseFailure({ error: err.message })))
      ))
    )
  );

  deleteWarehouse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarehousesActions.deleteWarehouse),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => WarehousesActions.deleteWarehouseSuccess({ id })),
        catchError(err => of(WarehousesActions.deleteWarehouseFailure({ error: err.message })))
      ))
    )
  );
}
